<div class="product-images-wrapper">
  <ng-container>
    <div class="main-image">
      <cx-media format="zoom" class="is-initialized is-missing" [class.is-missing-fish]="businessType === 'fish'">
      </cx-media>
    </div>
  </ng-container>
  <ng-container *ngIf="newThumbs$ as thumbs">
    <div class="gallery-images" *ngIf="thumbs.length">
      <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slickConfig">
        <div ngxSlickItem *ngFor="let item of thumbs" class="slide">
          <div class="gallery" *ngIf="item | async as items">
            <ng-container *ngIf="items as data">
              <cx-media
                *ngIf="data?.container?.product"
                [container]="getImageRendition(data?.container, 'secondary')"
                tabindex="0"
                format="product"
                (focus)="openImages(data?.container, false)"
                [class.is-active]="isActivePrimary(data?.container) | async"
                [class.is-missing-fish]="businessType === 'fish'"
              >
              </cx-media>
              <cx-media
                *ngIf="data?.container?.gallery"
                [container]="getImageRendition(data?.container, 'secondary')"
                tabindex="0"
                format="gallery"
                (focus)="openImages(data?.container, true)"
                [class.is-active]="isActive(data?.container) | async"
                [class.is-missing-fish]="businessType === 'fish'"
              >
              </cx-media>
            </ng-container>
          </div>
        </div>
      </ngx-slick-carousel>
    </div>
  </ng-container>
</div>
